/**
 * License Intelligence SAP Unit Consumption Mock Data
 *
 * Mock data for the unit consumption API endpoint.
 * In production, this data will come from:
 * GET /ECMv6/api/sodms/license-intelligence/v1/sap/overview/unit-consumption
 */

export interface UnitConsumptionMetric {
  value: number;
  label?: string;
  estimated?: boolean;
  utilization?: number;
  threshold?: string;
  remaining?: number;
  placeholder?: boolean;
}

export interface UnitConsumptionResponseData {
  totalUnitEntitlement: UnitConsumptionMetric;
  unitConsumed: UnitConsumptionMetric;
  unitAvailable: UnitConsumptionMetric;
  digitalAccessDocCount: UnitConsumptionMetric;
  defaultMode: boolean;
}

export interface UnitConsumptionResponse {
  data: UnitConsumptionResponseData;
  status: number;
  message: string;
}

export const LICENSE_INTELLIGENCE_UNIT_CONSUMPTION_DATA: UnitConsumptionResponse =
  {
    data: {
      totalUnitEntitlement: {
        value: 4200.0,
        label: 'Contract allocation',
        estimated: false,
      },
      unitConsumed: {
        value: 3847.0,
        utilization: 91.6,
        threshold: 'red',
        estimated: false,
      },
      unitAvailable: {
        value: 353.0,
        remaining: 8.4,
      },
      digitalAccessDocCount: {
        value: null as unknown as number,
        placeholder: true,
      },
      defaultMode: false,
    },
    status: 200,
    message: 'Unit consumption data retrieved successfully',
  };

export default LICENSE_INTELLIGENCE_UNIT_CONSUMPTION_DATA;
